export default "__VITE_ASSET__CjlZIXFR__"